import(/* webpackMode: "eager" */ "/home/runner/work/mm-js/mm-js/applications/content/app/[lang]/not-found.tsx");
